<template>
  <div>
    <div class="btBox">
      <div class="cont">
        <div class="logoimg img">
          <img src="../../assets/img/logo-p.png" @click="jump" alt="" srcset="" />
          <div class="shu"></div>
          <div class="name" @click="jump">注册</div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="title">注册信息填写表</div>
      <div v-show="lxOn == 0">
        <div class="cont">
          <div class="titleBox">
            <div class="shu"></div>
            <div class="name">基本信息</div>
          </div>
          <div class="box">
            <div class="name">姓名<span>*</span></div>
            <div class="inpBox">
              <div class="inp">
                <input type="text" v-model="name" placeholder="请输入姓名" />
              </div>
            </div>
          </div>
          <div class="box">
            <div class="name">联系方式<span>*</span></div>
            <div class="inpBox">
              <div class="inp">
                <input type="text" v-model="mobile" placeholder="请输入联系方式" />
              </div>
            </div>
          </div>
          <div class="box">
            <div class="name">验证码<span>*</span></div>
            <div class="inpBox">
              <div class="inp">
                <input type="text" v-model="yzmNum" placeholder="请输入验证码" />
              </div>
              <div class="yzmBox" v-if="!yzmShow" @click="yzmClick">
                获取验证码
              </div>
              <div class="yzmBox anxia" v-if="yzmShow">{{ time }}</div>
            </div>
          </div>
          <div class="box">
            <div class="name">密码<span>*</span></div>
            <div class="inpBox">
              <div class="inp">
                <input type="password" v-model="password" placeholder="请输入密码" />
              </div>
            </div>
          </div>
          <div class="box">
            <div class="name">确认密码<span>*</span></div>
            <div class="inpBox">
              <div class="inp">
                <input type="password" v-model="qDpassword" placeholder="请输入确认密码" />
              </div>
            </div>
          </div>
          <div class="box">
            <div class="name">注册身份<span>*</span></div>
            <div class="selectCont">
              <div class="seLi dis-cent" v-for="item in typeList" @click="typeClick(item.id)"
                :class="typeOn == item.id ? 'on' : ''">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
        <div class="cont" v-show="typeOn == 2">
          <div class="titleBox">
            <div class="shu"></div>
            <div class="name">公司信息</div>
          </div>
          <div class="box bz">
            <div class="bzBox">
              <div class="name">公司是否注册<span>*</span></div>
              <div class="selectCont">
                <div class="seLi dis-cent" :class="gsTypeOn == item.id ? 'on' : ''" v-for="item in gsTypeList"
                  @click="gsTypeClick(item.id)">
                  {{ item.name }}
                </div>
              </div>
            </div>
            <div class="bzTxt">
              备注：公司是否在平台注册过,如注册过直接选择即可
            </div>
          </div>
          <div v-show="gsTypeOn == 1">
            <div class="box">
              <div class="name">公司名称<span>*</span></div>
              <div class="inpBox">
                <a-select show-search :value="comValue" placeholder="请输入公司名称" style="width: 100%"
                  :default-active-first-option="false" :show-arrow="false" :filter-option="false"
                  :not-found-content="null" @search="handleSearch" @change="handleChange">
                  <a-select-option v-for="d in comData" :key="d.value">
                    {{ d.text }}
                  </a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div v-show="gsTypeOn == 2">
            <div class="box bz">
              <div class="bzBox">
                <div class="name">营业执照<span>*</span></div>
                <div class="imgBox">
                  <div class="img dis-cent" v-if="!imgUp" @click="uploadFile(1)">
                    <div class="iconfont icon-camera_fill"></div>
                  </div>
                  <div class="img" v-if="imgUp" @click="uploadFile(1)">
                    <img :src="$imgUrl + imgUp" alt="" />
                  </div>
                </div>
              </div>
              <div class="bzTxt">
                备注：上传公司营业执照图片，自动识别下方工商信息
              </div>
            </div>
            <div class="box">
              <div class="name">公司名称<span>*</span></div>
              <div class="inpBox">
                <div class="inp">
                  <input type="text" v-model="comInfo.name" placeholder="请输入公司名称" />
                </div>
              </div>
            </div>
            <div v-show="ycShow">
              <div class="box">
                <div class="name">法定代表人<span>*</span></div>
                <div class="inpBox">
                  <div class="inp">
                    <input type="text" v-model="comInfo.representative" placeholder="请输入法定代表人" />
                  </div>
                </div>
              </div>
              <div class="box">
                <div class="name">成立日期<span>*</span></div>
                <div class="inpBox">
                  <div class="inp">
                    <input type="text" v-model="comInfo.establish_time" placeholder="请输入成立日期" />
                  </div>
                </div>
              </div>
              <div class="box">
                <div class="name">企业类型<span>*</span></div>
                <div class="inpBox">
                  <div class="inp">
                    <input type="text" v-model="comInfo.cmpanytype" placeholder="请输入企业类型" />
                  </div>
                </div>
              </div>
              <div class="box">
                <div class="name">注册资金<span>*</span></div>
                <div class="inpBox">
                  <div class="inp">
                    <input type="text" v-model="comInfo.fund" placeholder="请输入注册资金" />
                  </div>
                </div>
              </div>
              <div class="box">
                <div class="name">注册地址<span>*</span></div>
                <div class="inpBox">
                  <div class="inp">
                    <input type="text" v-model="comInfo.residence" placeholder="请输入注册地址" />
                  </div>
                </div>
              </div>
              <div class="box">
                <div class="name">营业期限<span>*</span></div>
                <div class="inpBox">
                  <div class="inp">
                    <input type="text" v-model="comInfo.trade_time" placeholder="请输入营业期限" />
                  </div>
                </div>
              </div>
              <div class="box">
                <div class="name">统一社会信用代码<span>*</span></div>
                <div class="inpBox">
                  <div class="inp">
                    <input type="text" v-model="comInfo.yyzz" placeholder="请输入统一社会信用代码" />
                  </div>
                </div>
              </div>
              <div class="box">
                <div class="name">核准日期<span>*</span></div>
                <div class="inpBox">
                  <div class="inp">
                    <input type="text" v-model="comInfo.approval" placeholder="请输入核准日期" />
                  </div>
                </div>
              </div>
              <div class="box">
                <div class="name">登记机关<span>*</span></div>
                <div class="inpBox">
                  <div class="inp">
                    <input type="text" v-model="comInfo.registration" placeholder="请输入登记机关" />
                  </div>
                </div>
              </div>
              <div class="box">
                <div class="name">经营范围<span>*</span></div>
                <div class="textareaBox">
                  <div class="textarea">
                    <textarea v-model="comInfo.ranges" placeholder="请输入经营范围"></textarea>
                  </div>
                </div>
              </div>
            </div>
            <div class="box">
              <div class="modoBox" @click="ycShow = !ycShow">
                <div class="nameTxt">查看更多工商信息</div>
                <div class="iconfont icon-unfold" :class="ycShow ? 'ycOn' : ''"></div>
              </div>
            </div>
            <div class="box mab15">
              <div class="name">公司logo</div>
              <div class="imgsBox">
                <div class="img dis-cent" v-if="!logoImg" @click="uploadFile(3)">
                  <div class="iconfont icon-camera_fill"></div>
                </div>
                <div class="img" v-if="logoImg" @click="uploadFile(3)">
                  <img :src="$imgUrl + logoImg" alt="" />
                </div>
              </div>
            </div>
            <!-- <div class="box mab15">
              <div class="name">法人身份证<span>*</span></div>
              <div class="imgsBox">
                <div class="img dis-cent" style="flex-direction: column" v-if="!sfzZmImg" @click="uploadFile(4)">
                  <div class="iconfont icon-camera_fill"></div>
                  <div class="">点击上传身份证人像面</div>
                </div>
                <div class="img" v-if="sfzZmImg" @click="uploadFile(4)">
                  <img :src="$imgUrl + sfzZmImg" alt="" />
                </div>
                <div class="img dis-cent" style="flex-direction: column" v-if="!sfzFmImg" @click="uploadFile(5)">
                  <div class="iconfont icon-camera_fill"></div>
                  <div class="">点击上传身份证国徽面</div>
                </div>
                <div class="img" v-if="sfzFmImg" @click="uploadFile(5)">
                  <img :src="$imgUrl + sfzFmImg" alt="" />
                </div>
              </div>
            </div> -->
            <div class="box">
              <div class="name">办公区域<span>*</span></div>
              <div class="inpBox">
                <div class="xzBox" :class="district.length ? 'on' : ''" @click="districtClick">
                  <div class="text">{{ district_cn || '请选择办公区域' }}</div>
                  <div class="iconfont icon-enter"></div>
                </div>
              </div>
            </div>
            <div class="box">
              <div class="name">公司行业<span>*</span></div>
              <div class="inpBox">
                <div class="xzBox" :class="tradeOn ? 'on' : ''" @click="tradeClick">
                  <div class="text">{{ tradeTxt }}</div>
                  <div class="iconfont icon-enter"></div>
                </div>
              </div>
            </div>
            <div class="box">
              <div class="name">公司性质<span>*</span></div>
              <div class="inpBox">
                <a-dropdown>
                  <div class="xzBox" :class="nature ? 'on' : ''">
                    <div class="text">{{ nature_cn }}</div>
                    <div class="iconfont icon-enter"></div>
                  </div>
                  <a-menu slot="overlay" @click="hyClick" :selectedKeys="[nature]">
                    <a-menu-item :key="'公司性质_' + item.id + '_' + item.c_name" v-for="item in company">{{ item.c_name
                      }}</a-menu-item>
                  </a-menu>
                </a-dropdown>
              </div>
            </div>
            <div class="box">
              <div class="name">详细地址<span>*</span></div>
              <div class="areaBox">
                <a-input-search placeholder="搜索地址" enter-button @search="handleSearchauto" id="mapSearch"
                  v-model="searchValue" style="width: 100%" />
                <div class="map">
                  <div style="height: 15px"></div>
                  <div ref="mapContainer" :style="{ width: '100%', height: '350px' }" id="getMap"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btns">
        <div class="btn dis-cent">取消</div>
        <div class="btn dis-cent" @click="saveClick">提交</div>
      </div>
      <!-- <div class="contentRit" v-if="typeOn == 2">
        <div class="titles">公司资料填写</div>
        <div class="leixing">
          <div
            class="box dis-cent"
            v-for="(item, index) in lxList"
            :class="lxOn == index ? 'on' : ''"
            @click="lxClick(index)"
          >
            {{ item }}
          </div>
        </div>
      </div> -->
    </div>
    <input type="file" accept="image/*" ref="fileInput" @change="onFileChange" style="display: none" />
    <input type="file" accept="image/*" ref="imgsfileInput" @change="onimgsFileChange" style="display: none" />
    <input type="file" accept="image/*" ref="farenfileInput" @change="onfarenFileChange" style="display: none" />
    <input type="file" accept="image/*" ref="farenFmfileInput" @change="onfarenFmFileChange" style="display: none" />
    <input type="file" accept="image/*" ref="logofileInput" @change="onlogoFileChange" style="display: none" />
    <XuanzeLd v-if="ldShow" :ldData="tradeData" @show="ldShowDelClick" />
    <XuanzeQy v-if="quShow" :qyData="{ areaList: areaList, district: district, district_cn: district_cn }" @show="quDelClick" />
  </div>
</template>

<script>
import {
  Select,
  Form,
  Menu,
  Input,
  Button,
  Upload,
  Icon,
  Dropdown,
} from "ant-design-vue";
import TiandituLoader from "@/assets/js/tianditu";
import XuanzeLd from "../component/xuanzeLd.vue";
import XuanzeQy from "../component/xuanzeQy.vue";
export default {
  components: {
    "a-select": Select,
    "a-select-option": Select.Option,
    "a-form": Form,
    "a-form-item": Form.Item,
    "a-input": Input,
    "a-input-search": Input.Search,
    "a-button": Button,
    "a-textarea": Input.TextArea,
    "a-dropdown": Dropdown,
    "a-upload": Upload,
    "a-icon": Icon,
    "a-menu": Menu,
    "a-menu-item": Menu.Item,
    "a-sub-menu": Menu.SubMenu,
    XuanzeLd,
    XuanzeQy,
  },
  name: "",
  data() {
    return {
      tiandituApi: null,
      map: null,
      marker: null,
      placeSearch: null,
      maploading: false,
      ycShow: false,
      ldShow: false,
      jobtagOn: 0,
      jobtag: [],
      size: "default",
      lxOn: 0,
      lxList: ["基础资料", "详细信息"],
      searchValue: "",
      center: [121.219406, 28.119613],
      typeOn: 1,
      typeList: [
        {
          name: "个人求职注册",
          id: 1,
        },
        {
          name: "企业注册",
          id: 2,
        },
      ],
      yzmShow: false,
      gsTypeOn: 1,
      gsTypeList: [
        {
          name: "是",
          id: 1,
        },
        {
          name: "否",
          id: 2,
        },
      ],
      value: undefined,
      imgUp: "",
      comInfo: {},
      imgs: [],
      welfare: [],
      jbTypeOn: 0,
      jbTypeList: [
        {
          name: "经常加班",
        },
        {
          name: "偶尔加班",
        },
        {
          name: "基本不加班",
        },
      ],
      jbfTypeOn: 0,
      jbfTypeList: [
        {
          name: "有",
        },
        {
          name: "没有",
        },
      ],
      district_cn: "请选择办公区域",
      areaList: [
        {
          id: 3723,
          pid: 1146,
          code: 0,
          name: "玉城",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3724,
          pid: 1146,
          code: 0,
          name: "坎门",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3725,
          pid: 1146,
          code: 0,
          name: "大麦屿",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3726,
          pid: 1146,
          code: 0,
          name: "楚门",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3727,
          pid: 1146,
          code: 0,
          name: "清港",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3728,
          pid: 1146,
          code: 0,
          name: "龙溪",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3729,
          pid: 1146,
          code: 0,
          name: "芦浦",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3730,
          pid: 1146,
          code: 0,
          name: "沙门",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3731,
          pid: 1146,
          code: 0,
          name: "干江",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3732,
          pid: 1146,
          code: 0,
          name: "鸡山",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
        {
          id: 3733,
          pid: 1146,
          code: 0,
          name: "海山",
          car: "",
          is_sent: 1,
          is_delete: 0,
          children: null,
        },
      ],
      district: [],
      quShow: false,
      tradeOn: "",
      tradeTxt: "请选择公司行业",
      tradeData: {
        tradeTxt: "",
      },
      logoImg: "",
      size: "请选择企业规模",
      size_id: "",
      email: "",
      url: "",
      name: "",
      qDpassword: "",
      password: "",
      mobile: "",
      nature: "",
      nature_cn: "请选择公司性质",
      company: [],
      yzmNum: "",
      comData: [],
      page: {
        pageNo: 1,
        pageSize: 10,
      },
      comValue: undefined,
      time: 60,
      sfzZmImg: "",
      sfzFmImg: "",
    };
  },
  created() {
    TiandituLoader.load()
      .then((Tianditu) => {
        this.tiandituApi = Tianditu;
        this.initMapWhenVisible();
      })
      .catch((error) => {
        this.maploading = false;
        console.error("天地图加载失败", error);
      });
    let category_gets = window.localStorage.getItem("category_gets");
    if (category_gets) {
      this.category_gets = JSON.parse(category_gets);
      this.typeHcGet(this.category_gets);
    } else {
      this.typeGet();
    }
    this.conGet();
  },
  methods: {
    jump() {
      this.$router.push({
        path: "/index",
      });
    },
    conGet() {
      this.$get("/nozzle/web/company_search", this.page).then((res) => {
        console.log(res.data);
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            const e = res.data[i];
            this.comData.push({
              value: e.id,
              text: e.name,
            });
          }
        }
      });
    },
    saveClick() {
      let info = {
        mobile: this.mobile,
        utype: this.typeOn == 1 ? 2 : 1,
        password: this.password,
        name: this.name,
        code: this.yzmNum,
      };
      if (!this.name) {
        this.$message.error("请填写姓名");
        return;
      }
      if (!this.mobile) {
        this.$message.error("请填写手机号码");
        return;
      }
      if (!this.yzmNum) {
        this.$message.error("请填写验证码");
        return;
      }
      if (!this.password) {
        this.$message.error("请填写密码");
        return;
      }
      if (!this.qDpassword) {
        this.$message.error("请填写确认密码");
        return;
      }
      if (this.password != this.qDpassword) {
        this.$message.error("密码和确认密码不同");
        return;
      }
      let data = {};
      if (this.typeOn == 2 && this.gsTypeOn == 2) {
        for (let i = 0; i < this.imgs.length; i++) {
          const element = this.imgs[i];
        }
        if (!this.imgUp) {
          this.$message.error("请上传营业执照");
          return;
        }
        if (!this.comInfo.name) {
          this.$message.error("请填写公司名称");
          return;
        }
        // if (!this.sfzZmImg) {
        //   this.$message.error("请上传法人人像面身份证");
        //   return;
        // }
        // if (!this.sfzFmImg) {
        //   this.$message.error("请上传法人国徽面身份证");
        //   return;
        // }
        if (this.district.length === 0) {
          this.$message.error("请选择办公区域");
          return;
        }
        if (this.tradeTxt == "请选择公司行业") {
          this.$message.error("请选择公司行业");
          return;
        }
        if (this.nature_cn == "请选择公司性质") {
          this.$message.error("请选择公司性质");
          return;
        }
        if (!this.address) {
          this.$message.error("请选择详细地址");
          return;
        }
        data = {
          ...this.comInfo,
          certificate_img: this.imgUp,
          logo: this.logoImg,
          // idcardz: this.sfzZmImg,
          // idcardf: this.sfzFmImg,
          address: this.address,
          lng: Number(this.center[0]),
          lat: Number(this.center[1]),
          district_cn: "台州/玉环/" + this.district_cn.split(",").join("|台州/玉环/"),
          district: this.district.map(id => "1142,1146," + id).join("|"),
          trade: Number(this.tradeOn),
          trade_cn: this.tradeTxt,
          nature_cn: this.nature_cn,
          nature: Number(this.nature.split("_")[1]),
        };
        info.data = JSON.stringify(data);
      }
      if (this.typeOn == 2 && this.gsTypeOn == 1) {
        if (!this.comValue) {
          this.$message.error("请选择公司");
          return;
        }
        info.utype = 2
        info.company_id = Number(this.comValue);
      }
      console.log(info);
      this.$post("/nozzle/web/register", info).then((res) => {
        console.log(res);
        if (res.data.status == 1) {
          this.$message.success("注册成功");
          this.$router.push({
            path: "/login",
            query: {},
          });
        } else {
          this.$message.error(res.data.msg);
        }
      });
      console.log(info);
    },
    tradeClick() {
      this.ldShow = true;
    },
    ldShowDelClick(data) {
      this.ldShow = false;
      if (data) {
        this.tradeData = data;
        this.tradeTxt = data.tradeTxt;
        this.tradeOn = data.tradeOn;
      }
    },
    districtClick() {
      this.quShow = true;
    },
    quDelClick(data) {
      this.quShow = false;
      if (data) {
        this.district = data.district;
        this.district_cn = data.district_cn;
      }
    },
    hyClick(e) {
      let key = e.key.split("_");
      if (key[0] == "公司性质") {
        this.nature = e.key;
        this.nature_cn = key[2];
      }
    },
    gmClick(e) {
      let key = e.key.split("_");
      this.size = key[2];
      this.size_id = key[1];
    },
    jbTypeClick(name) {
      this.jbTypeOn = name;
    },
    jbfTypeClick(name) {
      this.jbfTypeOn = name;
    },
    typeGet() {
      this.$get("/common/category_gets", {
        pageNo: -1,
      }).then((res) => {
        window.localStorage.setItem("category_gets", JSON.stringify(res.data));
        this.typeHcGet(res.data);
      });
    },
    typeHcGet(data) {
      // 职位亮点
      let jobtag = [];
      // 企业规模
      let scale = [];
      // 企业规模
      let company = [];
      for (let i = 0; i < data.length; i++) {
        const e = data[i];
        e.select = false;
        if (e.c_alias == "QS_jobtag") {
          jobtag.push(e);
        }
        if (e.c_alias == "QS_scale") {
          scale.push(e);
        }
        if (e.c_alias == "QS_company_type") {
          company.push(e);
        }
      }
      this.scale = scale;
      this.jobtag = jobtag;
      this.company = company;
    },
    jobtagClick(i) {
      this.jobtag[i].select = !this.jobtag[i].select;
      let welfare = [];
      for (let i = 0; i < this.jobtag.length; i++) {
        const e = this.jobtag[i];
        if (e.select) {
          welfare.push(e.c_name);
        }
      }
      welfare = welfare.join(",");
      this.welfare = welfare;
    },
    imgClick(e) {
      this.img = e;
    },
    onFileChange(e) {
      if (!e.target.files) {
        return;
      }
      var formData = new FormData();
      formData.append("file", e.target.files[0]);
      formData.append("mobile", this.mobile);
      formData.append("vcode", this.yzmNum);
      formData.append("where", "company_register");
      this.$uploadfile("/common/fileupload_company", formData).then((res) => {
        if (res.data.status) {
          this.imgUp = res.data.data.path_name;
          this.sbGet(res.data.data.path_name);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    sbGet(url) {
      this.$post("/nozzle/web/recognition", {
        url,
      }).then((res) => {
        console.log(res);
        if (res.data.status == 1) {
          let data = res.data.data.words_result;
          this.$message.success("识别成功");
          this.comInfo.name = data["单位名称"].words;
          this.comInfo.representative = data["法人"].words;
          this.comInfo.establish_time = data["成立日期"].words;
          this.comInfo.cmpanytype = data["类型"].words;
          this.comInfo.fund = data["注册资本"].words.split("万")[0];
          this.comInfo.fund_type = "万" + data["注册资本"].words.split("万")[1];
          this.comInfo.residence = data["地址"].words;
          this.comInfo.trade_time =
            data["有效期"].words + "-" + data["有效期"].words;
          this.comInfo.yyzz = data["社会信用代码"].words;
          this.comInfo.approval = data["核准日期"].words;
          this.comInfo.registration = data["登记机关"].words;
          this.comInfo.ranges = data["经营范围"].words;
          console.log(this.comInfo);
          this.$forceUpdate();
        } else {
          this.imgUp = "";
          this.$message.error(res.data.msg);
        }
      });
    },
    uploadFile(type) {
      if (type == 1) {
        this.$refs.fileInput.click();
      }
      if (type == 2) {
        this.$refs.imgsfileInput.click();
      }
      if (type == 3) {
        this.$refs.logofileInput.click();
      }
      if (type == 4) {
        this.$refs.farenfileInput.click();
      }
      if (type == 5) {
        this.$refs.farenFmfileInput.click();
      }
    },
    onfarenFileChange(e) {
      if (!e.target.files) {
        return;
      }
      var formData = new FormData();
      formData.append("file", e.target.files[0]);
      formData.append("where", "product");
      this.$uploadfile("/common/fileupload", formData).then((res) => {
        if (res.data.status) {
          this.sfzZmImg = res.data.data.path_name;
        } else {
          this.$message.error("网络繁忙,请稍后再试~");
        }
      });
    },
    onfarenFmFileChange(e) {
      if (!e.target.files) {
        return;
      }
      var formData = new FormData();
      formData.append("file", e.target.files[0]);
      formData.append("where", "product");
      this.$uploadfile("/common/fileupload", formData).then((res) => {
        if (res.data.status) {
          this.sfzFmImg = res.data.data.path_name;
        } else {
          this.$message.error("网络繁忙,请稍后再试~");
        }
      });
    },
    onimgsFileChange(e) {
      if (!e.target.files) {
        return;
      }
      var formData = new FormData();
      formData.append("file", e.target.files[0]);
      formData.append("where", "product");
      this.$uploadfile("/common/fileupload", formData).then((res) => {
        if (res.data.status) {
          this.imgs.push(res.data.data);
        } else {
          this.$message.error("网络繁忙,请稍后再试~");
        }
      });
    },
    onlogoFileChange(e) {
      if (!e.target.files) {
        return;
      }
      var formData = new FormData();
      formData.append("file", e.target.files[0]);
      formData.append("mobile", this.mobile);
      formData.append("vcode", this.yzmNum);
      formData.append("where", "company_register");
      this.$uploadfile("/common/fileupload_company", formData).then((res) => {
        if (res.data.status) {
          this.logoImg = res.data.data.path_name;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    imgDelClick(i) {
      this.imgs.splice(i, 1);
    },
    handleSearch(value) {
      console.log(value);
      this.page.name = value;
      this.comData = [];
      this.conGet();
    },
    handleChange(value) {
      this.comValue = value;
    },
    gsTypeClick(id) {
      this.gsTypeOn = id;
      this.initMapWhenVisible();
    },
    yzmClick() {
      if (!this.mobile) {
        this.$message.error("请先输入手机号");
        return;
      }
      this.yzmShow = true;
      this.timeYs = setInterval(() => {
        if (this.time == 0) {
          this.yzmShow = false;
          this.time = 60;
          clearInterval(this.timeYs);
        } else {
          this.time--;
        }
      }, 1000);
      this.$post("/common/sms_send", {
        mobile: this.mobile,
      }).then((res) => {
        console.log(res);
        if (res.data.status == 1) {
          this.$message.success("发送成功");
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    typeClick(id) {
      this.typeOn = id;
      this.initMapWhenVisible();
    },
    initMapWhenVisible() {
      if (
        this.typeOn != 2 ||
        this.gsTypeOn != 2 ||
        !this.tiandituApi ||
        this.map
      ) {
        return;
      }
      this.$nextTick(() => {
        window.requestAnimationFrame(() => {
          const container = this.$refs.mapContainer;
          if (
            container &&
            container.offsetWidth > 0 &&
            container.offsetHeight > 0 &&
            !this.map
          ) {
            this.showMap(this.tiandituApi);
          }
        });
      });
    },
    mapinit() {
      this.map.remove(this.marker);
      this.addMark(this.map, this.center);
      this.map.setCenter(this.center);
    },
    showMap(Tianditu) {
      this.tiandituApi = Tianditu;
      console.log(this.center);
      this.maploading = true;
      this.map = new Tianditu.Map("getMap", {
        resizeEnable: true,
        center: this.center,
        zoom: 13,
      });
      console.log(this.center);
      this.marker = new Tianditu.Marker({
        position: this.center,
        offset: new Tianditu.Pixel(-13, -30),
      });
      // 添加点坐标

      this.map.add(this.marker);
      Tianditu.plugin(
        [
          "Tianditu.ToolBar",
          "Tianditu.Scale",
          "Tianditu.OverView",
          "Tianditu.MapType",
          "Tianditu.Geolocation",
          "Tianditu.Geocoder",
          "Tianditu.GeometryUtil",
        ],
        function () { }
      );
      const autoOptions = {
        input: "mapSearch",
        city: "331000",
      };
      const auto = new Tianditu.Autocomplete(autoOptions);
      this.placeSearch = new Tianditu.PlaceSearch({
        map: this.map,
        city: "331004",
      }); // 构造地点查询类
      this.maploading = false;
      Tianditu.event.addListener(auto, "select", this.select);
      this.map.on("click", (e) => {
        // 移除旧的点坐标
        this.map.remove(this.marker);
        // 获取点击的经纬度
        this.center = [e.lnglat.lng, e.lnglat.lat];
        // 植入新的点坐标
        console.log(e.lnglat.lng, e.lnglat.lat);
        this.lng = e.lnglat.lng;
        this.lat = e.lnglat.lat;
        this.map.setCenter(this.center);
        this.addMark(this.map, this.center);
        this.getAddress(this.center);
      });
    },
    select(e) {
      console.log(e);
      this.map.remove(this.marker);
      this.center = [e.poi.location.lng, e.poi.location.lat];
      this.addMark(this.map, this.center);
      this.map.setCenter(this.center);
      this.getAddress(this.center);
    },
    addMark(map, points) {
      console.log("触发addmark");
      // eslint-disable-next-line no-undef
      this.marker = new this.tiandituApi.Marker({
        map: map,
        position: points,
        draggable: true, // 允许拖动
        cursor: "move",
        raiseOnDrag: true,
        title: "中心",
      });
      this.marker.on("dragend", (e) => {
        const position = this.marker.getPosition();
        // 存下坐标与地址
        this.point = [position.lng, position.lat];
        this.lng = position.lng;
        this.lat = position.lat;
        this.center = [position.lng, position.lat];
        this.getAddress([position.lng, position.lat]);
      });
    },
    getAddress(points) {
      // eslint-disable-next-line no-undef
      const geocoder = new this.tiandituApi.Geocoder({ radius: 1000 });
      geocoder.getAddress(points, (status, result) => {
        if (status === "complete" && result.regeocode) {
          console.log(result);
          // eslint-disable-next-line camelcase
          const s_addr =
            result.regeocode.addressComponent.province +
            "-" +
            result.regeocode.addressComponent.city +
            "-" +
            result.regeocode.addressComponent.district;
          const addreesd = result.regeocode.formattedAddress; // 全部地址名称
          const houzhi = addreesd.substring(s_addr.length); // 获取具体街道

          this.addressText = addreesd;
          this.address = addreesd;
          this.searchValue = addreesd;
          console.log(this.address);
          // this.address = s_addr + "," + houzhi;
        }
      });
    },
    handleSearchauto(e) {
      this.dataSource = [];
      this.searchValue = e;
      this.placeSearch.search(this.searchValue, (status, result) => {
        console.log(result);
        if (result.poiList.pois) {
          this.map.remove(this.marker);
          this.center = [
            result.poiList.pois[0].location.lng,
            result.poiList.pois[0].location.lat,
          ];
          this.addMark(this.map, this.center);
          this.map.setCenter(this.center);
          this.getAddress(this.center);
        }
      });
    },
    lxClick(i) {
      this.lxOn = i;
    },
    btns() { },
  },
  mounted() { },
  computed: {},
};
</script>
<style lang="less" scoped>
/deep/.ant-select-selection--single {
  height: 36px;
}

/deep/.ant-select-selection__rendered {
  line-height: 35px;
}

.btBox {
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;
  background-color: #fff;
  box-shadow: 0 2px 2px 1px whitesmoke;
  font-family: PingFangSC-Regular, sans-serif;

  .cont {
    width: 1440px;
    margin: auto;
    display: flex;
    height: 55px;
    align-items: center;
    justify-content: space-between;

    .logoimg {
      height: 30px;
      display: flex;
      align-items: center;

      img {
        height: 100%;
        width: auto;
        cursor: pointer;
      }

      .shu {
        width: 1px;
        height: 15px;
        margin: 0 10px;
        background-color: #999;
      }

      .name {
        font-size: 18px;
        font-weight: 700;
        color: #333;
        cursor: pointer;
      }
    }
  }
}

.content {
  width: 1280px;
  margin: auto;
  margin-top: 80px;
  border-radius: 10px;
  background-color: #fff;
  padding: 40px;
  position: relative;

  .title {
    text-align: center;
    font-size: 20px;
    font-weight: 600;
  }

  .cont {
    padding: 20px 50px;
    padding-bottom: 0;

    .titleBox {
      display: flex;
      align-items: center;
      margin-bottom: 30px;

      .shu {
        width: 4px;
        border-radius: 4px;
        height: 20px;
        background-color: #1382eb;
      }

      .name {
        font-weight: 600;
        font-size: 16px;
        margin-left: 10px;
      }
    }

    .bz {
      flex-direction: column;
    }

    .box {
      margin-bottom: 30px;
      display: flex;
      width: 700px;

      .modoBox {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        margin-bottom: 20px;
        color: #147ee0;
        margin-top: -15px;

        .nameTxt {
          cursor: pointer;
          font-size: 14px;
        }

        .iconfont {
          font-size: 14px;
        }

        .ycOn {
          transform: rotate(180deg);
        }
      }

      .bzBox {
        display: flex;
      }

      .bzTxt {
        padding-left: 100px;
        font-size: 12px;
        color: #9c9c9c;
        margin-top: 5px;
      }

      .name {
        width: 100px;
        margin-top: 6px;
        padding-right: 10px;

        span {
          color: #ee0909;
        }
      }

      .inpBox {
        width: calc(100% - 100px);
        height: 35px;
        position: relative;

        .xzBox {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 100%;
          box-sizing: border-box;
          border: 1px solid #ebebeb;
          border-radius: 5px;
          box-sizing: border-box;
          padding: 0 15px;
          color: #888;
          cursor: pointer;
        }

        .on {
          color: #000;
        }

        .inp {
          height: 100%;
          box-sizing: border-box;
          border: 1px solid #ebebeb;
          border-radius: 5px;
          box-sizing: border-box;
          padding-left: 15px;

          input {
            width: 100%;
            height: 100%;
          }
        }

        .yzmBox {
          position: absolute;
          top: 1px;
          right: 1px;
          width: 80px;
          height: calc(100% - 2px);
          background-color: #0864ce;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          font-size: 12px;
        }

        .anxia {
          background-color: #999;
        }
      }

      .areaBox {
        width: calc(100% - 100px);
        height: 400px;

        .img {
          width: 300px;
          height: 200px;
          box-sizing: border-box;
          border: 1px solid #ebebeb;
          border-radius: 5px;

          .iconfont {
            font-size: 40px;
            color: #c9c9c9;
          }
        }
      }

      .imgBox {
        width: calc(100% - 100px);
        box-sizing: border-box;

        .img {
          width: 300px;
          height: 200px;
          box-sizing: border-box;
          border: 1px solid #ebebeb;
          border-radius: 5px;
          cursor: pointer;

          .iconfont {
            font-size: 40px;
            color: #c9c9c9;
          }
        }
      }

      .imgsBox {
        width: calc(100% - 100px);
        display: flex;
        flex-wrap: wrap;

        .img {
          width: calc(33.33% - 10px);
          height: 120px;
          border-radius: 5px;
          border: 1px solid #ebebeb;
          color: #9c9c9c;
          margin-right: 15px;
          margin-bottom: 15px;
          cursor: pointer;
          position: relative;

          .iconfont {
            font-size: 30px;
          }

          .cha {
            position: absolute;
            top: 0;
            right: 0;
            width: 22px;
            height: 22px;
            border-bottom-left-radius: 5px;
            background-color: rgba(0, 0, 0, 0.4);
            color: #fff;
            cursor: pointer;

            .iconfont {
              font-size: 12px;
            }
          }
        }

        .img:nth-child(3n) {
          margin-right: 0;
        }
      }

      .textareaBox {
        width: calc(100% - 100px);
        height: 200px;

        .textarea {
          width: 600px;
          height: 100%;
          box-sizing: border-box;
          border: 1px solid #ebebeb;
          border-radius: 5px;
          box-sizing: border-box;
          padding: 10px 15px;

          textarea {
            width: 100%;
            height: 100%;
            border: none;
            resize: none;
          }
        }
      }

      .selectCont {
        overflow: hidden;
        width: calc(100% - 100px);

        .seLi {
          height: 35px;
          padding: 0 20px;
          border: 1px solid #d4d4d4;
          border-radius: 5px;
          color: #888;
          margin-right: 15px;
          float: left;
          cursor: pointer;
          margin-bottom: 15px;
        }

        .on {
          border: 1px solid #1382eb;
          background-color: #1382eb;
          color: #fff;
        }
      }
    }

    .mab15 {
      margin-bottom: 15px;
    }
  }

  .btns {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 50px;

    .btn {
      margin-right: 30px;
      cursor: pointer;
      height: 40px;
      border-radius: 5px;
      width: 90px;
      box-sizing: border-box;
      border: 1px solid #ebebeb;
    }

    .btn:last-child {
      color: #fff;
      background-color: #1382eb;
      margin-right: 0;
    }
  }
}

.contentRit {
  width: 450px;
  padding-left: 60px;
  box-sizing: border-box;
  position: absolute;
  top: 90px;
  right: 50px;

  .titles {
    font-weight: 600;
    font-size: 20px;
    margin-bottom: 5px;
  }

  .leixing {
    display: flex;
    margin-top: 15px;

    .box {
      width: calc(50% - 10px);
      height: 50px;
      margin-right: 20px;
      border: 1px solid #ebebeb;
      border-radius: 5px;
      cursor: pointer;
    }

    .box:last-child {
      margin-right: 0;
    }

    .on {
      color: #fff;
      background-color: #147ee0;
    }
  }

  .text {
    margin-top: 15px;
    color: #9c9c9c;
  }
}
</style>
